import { render, staticRenderFns } from "./ModalPaidVerification.vue?vue&type=template&id=af5fbc74&"
import script from "./ModalPaidVerification.vue?vue&type=script&lang=js&"
export * from "./ModalPaidVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports